/* global axios */
import ApiClient from './ApiClient';

class TalkviaGoogleMapsConfigAPI extends ApiClient {
  constructor() {
    super('talkvia_google_maps_config', { accountScoped: true });
  }

  update(data) {
    return axios.patch(this.url, { talkvia_google_maps_config: data });
  }
}

export default new TalkviaGoogleMapsConfigAPI();
